<template>
  <div class="oc-chat-message-group">
    <div v-if="userMessage" class="oc-chat-content-user">
      <div >
        <i class="fa fa-comment oci-blue" ></i>&nbsp;
        <span class="oc-message-sender-name">{{ item.senderName }}</span>
        <span class="oc-message-sent-time">{{ item.sentTime }}</span>
      </div>
      <div class="oc-message-content">
        {{ item.content }}
      </div>

    </div>
    <div v-if="!userMessage" class="oc-chat-content-participant">
      <div>
        <i class="fa fa-comment oci-yellow" ></i>&nbsp;
        <span class="oc-message-sender-name">{{ item.senderName }}</span>
        <span class="oc-message-sent-time">{{ item.sentTime }}</span>
      </div>
        <div class="oc-message-content">
          {{ item.content }}
        </div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "ChatMessage",
      data(){
          return {
            userMessage:false
          }
      },
        props:{
          item:Object,
          sender: Number
        },
      methods:{
        checkUserMessage(){
          this.ociLog("Inside chatUserMessage")
          if (this.item.sender===this.sender){
            this.userMessage= true;
          }
          else {
            this.userMessage = false;
          }

        },
      },
      mounted(){
      this.checkUserMessage();
      }
    }
</script>

<style scoped>
.oc-chat-message-group{
  padding-top : 2px;
  margin:0px 10px 0px 0px;
}
  .oc-chat-content-user{
    background-color: #bdeafe;
    padding:4px 4px 4px 10px;;
    border-radius: 0px 10px 10px 14px;
  }
.oc-chat-content-participant{
  background-color: #e5e5db;
  border-radius: 0px 10px 10px 14px;
  padding:4px 4px 4px 10px;;
}
  .oc-message-sent-time{
    font-size: .8em;
    float:right;
  }
.oc-message-sent-time{

  font-size: .8em;
}
.oc-message-content{
  word-wrap: break-word;
}


</style>
